import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  card: {
    '&:hover': {
      backgroundColor: theme.tokens.colors.bg.greyscale.tertirary,
    },
  },
}));
